import './index.scss';
import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { ActionType } from 'types/action';
import { IInspectionContext, InspectionContext } from 'context/inspections';
import CpeClient from 'shared/clients/CPE';
import { CpeDocData } from 'types/cpeDocs';
import DocsQuestions, {
  DocsDataQuestions,
  DocsQuestionsState,
} from 'components/claims/docsQuestions';

interface Props {
  onComplete: () => void;
}

const AdditionalDocs = ({ onComplete }: Props): JSX.Element => {
  const { state: ctx, dispatch } = useContext<IInspectionContext>(
    InspectionContext,
  );
  const [docsQuestions, setDocsQuestions] = useState<DocsDataQuestions[]>([]);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const validateDocsQuestions = (
    tmpDocData?: DocsQuestionsState[],
  ): boolean => {
    const currentListData = tmpDocData ?? ctx.cpeDocumentValidation;
    const questionnaireIsValid = currentListData?.every(
      (item) => item.selectableValue === true || item.selectableValue === false,
    );

    setIsDisabled(!questionnaireIsValid);

    return questionnaireIsValid ?? false;
  };

  const saveQuestionSelection = (
    documentsStates: DocsQuestionsState[],
  ): void => {
    CpeDocData.forEach((doc) => {
      const docIndex = documentsStates.findIndex(
        (docState) => docState.documentType === doc.type,
      );
      if (docIndex === -1) {
        documentsStates.push({
          documentType: doc.type,
          selectableValue: false,
        });
      }
    });
    dispatch({
      type: ActionType.SET_CPE_DOCUMENT_VALIDATION,
      payload: documentsStates,
    });
    validateDocsQuestions(documentsStates);
  };

  const handleContinue = (): void => {
    if (validateDocsQuestions()) {
      onComplete();
    }
  };

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        if (ctx.cpeId) {
          const cpeClient = new CpeClient();
          const statusDocs = await cpeClient.getDocumentsStatus(ctx.cpeId);
          const documents: DocsDataQuestions[] = [];

          if (statusDocs?.documents?.pending) {
            statusDocs?.documents?.pending.forEach((item: any) => {
              documents.push({
                documentType: item.type,
                description: item.description,
              });
            });
          }

          setDocsQuestions(documents);
        } else {
          // eslint-disable-next-line no-console
          console.info('CPE :: No claim found');
        }
      } catch (error) {
        console.error('Error fetch claim:', error);
      }
    })();
  }, []);

  useEffect(() => {
    validateDocsQuestions();
  }, []);

  return (
    <div className="add-docs">
      <DocsQuestions
        documents={docsQuestions}
        onResult={saveQuestionSelection}
      />
      <div>
        <Button
          id="continue-btn"
          variant="contained"
          size="large"
          disabled={isDisabled}
          onClick={handleContinue}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default AdditionalDocs;
